import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ServiceEntryBlockData from '../../../Models/Content/ServiceEntryBlockData';

const ServiceEntryBlockView = require('./ServiceEntryBlock.js').default;

export default class ServiceEntryBlockComponent extends EpiComponent<ServiceEntryBlockData> {
  public componentDidMount(): void {
    try {
      this.getContext()?.getStore()?.dispatch({
        type: 'serviceEntryBlock/reportDWH',
        payload: {
          actionType: 'SupportCenterMainPage',
          status: 'Ongoing',
          messageText: 'Support Center Main Page Displayed',
        },
      });
    } catch {}
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <ServiceEntryBlockView iContent={this.props.data} />;
  }
}
